<template>
    <div class="ppcurve">
         <div class="menu">
            <el-form :inline="true" >
               <el-form-item label="选择支线">
                <el-select placeholder="请选择支线" v-model="pipelineId" @change="changePipelineId">
                    <el-option label="耕德电子站点侧支线" value="1"></el-option>
                    <el-option label="顶益400支线" value="2"></el-option>
                    <el-option label="娃哈哈200支线" value="3"></el-option>
                    <el-option label="味全食品支线" value="4"></el-option>
                    <el-option label="耕德电子测点间支线" value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-button plain type="primary" class="menu-btn" @click="presetTime('day')">一天
              </el-button>
              <el-button plain type="primary" class="menu-btn" @click="presetTime('week')">
                一周
              </el-button>
              <el-button plain type="primary" class="menu-btn" @click="presetTime('month')">
                一个月
              </el-button>
              <el-button plain type="primary" class="years menu-btn" @click="presetTime('year')">
                一年
              </el-button>

              <el-form-item label="开始时间">
                <!--日期-->
                <el-date-picker
                  v-model="start_time"
                  type="datetime"
                  class="start_date date-input"
                  placeholder="开始时间">
                </el-date-picker>
              </el-form-item>
      
              <el-form-item label="结束时间">
                <!--日期-->
                <el-date-picker
                  v-model="end_time"
                  type="datetime"
                  class="end_date date-input"
                  placeholder="结束时间">
                </el-date-picker>
              </el-form-item>

              <el-button plain type="primary" class="menu-btn" @click="searchData()">
                <span>查询</span>
              </el-button>
            </el-form>
        </div>
        <div v-if="historyData.length<=0" class="blank">暂无数据</div>
        <div class="chart-wrap" v-else>
            <div class="analysis_chart">
                <div class="flowHeat_flowMas chart_item" id="flowHeat_flowMas"></div>
                <div class="velocity chart_item" id="velocity"></div>
                <div class="hLoss chart_item" id="hLoss"></div>
            </div>
            <div class="analysis_chart">
                <div class="heatLossRate chart_item" id="heatLossRate"></div>
                <div class="heatLossPerMeter chart_item" id="heatLossPerMeter"></div>
                <div class="heatLossPerSquare1_heatLossPerSquare2 chart_item" id="heatLossPerSquare1_heatLossPerSquare2"></div>
            </div>
        </div>

    </div>
</template>
<script>
import {getPipelineAnalysis} from "@api/decision"
import echarts from 'echarts/lib/echarts';
// 引入柱状图
import 'echarts/lib/chart/bar';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';

export default {
    name:"ppcurve",
    data(){
        return {
            pipelineId:"1" , // 管道编号
            start_time:"" , // 开始时间
            end_time:"", // 结束时间
            historyData:[], //历史数据

            page:{ // 分页参数
                total:0, // 数据总量
                size:500, // 每页个数
                current:1, // 当前页
                totalPage:0 // 总页数
            },

            flowHeat_flowMas_chart:null, //瞬时流量和瞬时热量曲线
            velocity_chart:null ,// 流速曲线
            hLoss_chart:null, // 焓降曲线
            heatLossRate_chart:null,// 热损率曲线
            heatLossPerMeter_chart:null, // 单位长度热损
            heatLossPerSquare1_heatLossPerSquare2_chart:null, // 单位面积热损

            chunckTimeId:null, // 拆分管道数据的定时器
            messageTip:null, // 提示框
        }
    },
    mounted(){
        // 获取当前时间，并格式化
        let now=new Date();
        let nowObj=this.$moment(now);
        this.end_time=nowObj.format("yyyy-MM-DD HH:mm:ss");
        this.start_time=nowObj.add(-1,'days').format("yyyy-MM-DD HH:mm:ss");

        // 获取管段历史数据
        this.$nextTick(()=>{
            this.getPipelineAnalysisHistory(1,500);
        });

    },
    methods:{
        // 获取管段的历史数据
        getPipelineAnalysisHistory(page,size,append){
            page=page||this.page.current;
            size=size||this.page.size;
            getPipelineAnalysis(this.pipelineId,this.start_time,this.end_time,page,size).then(res=>{
                // 设置数据
                if(res.status&&res.status==200){
                    let resdata=res.content;

                    // 设置数据,如果是追加的话，将数据保存到相应的数组中，否则就是替换
                    if(append){
                        this.historyData=this.historyData.concat(resdata.content);
                    }else{
                        this.historyData=resdata.content;
                    }
                    let data=this.historyData;

                    // 如果数据为空
                    if(data.length<=0){
                        return;
                    }

                    // 设置分页
                    let tempPage={};
                    tempPage.current=resdata.number+1;
                    tempPage.size=resdata.size;
                    tempPage.total=resdata.totalElements;
                    tempPage.totalPage=Math.ceil(resdata.totalElements/resdata.size);
                    this.page=tempPage;

                    // 瞬时流量和瞬时热量曲线
                    if(!this.flowHeat_flowMas_chart){ // 如果不存在，则创建
                        // 防止未渲染出div
                        this.$nextTick(()=>{
                            this.flowHeat_flowMas_chart_creat("flowHeat_flowMas",data);
                        });
                    }else{// 否则更新数据
                        //刷新数据
                        let option = this.flowHeat_flowMas_chart.option;
                        option.dataset.source=data;
                        this.flowHeat_flowMas_chart.setOption(option); 
                    }

                    // 流速曲线
                    if(!this.velocity_chart){
                        this.$nextTick(()=>{
                            this.velocity_chart_creat("velocity",data);
                        });

                    }else{
                        //刷新数据
                        let option = this.velocity_chart.option;
                        option.dataset.source=data;
                        this.velocity_chart.setOption(option);
                    }

                    // 焓降曲线
                    if(!this.hLoss_chart){
                        this.$nextTick(()=>{
                            this.hLoss_chart_creat("hLoss",data);
                        })

                    }else{
                        //刷新数据
                        let option = this.hLoss_chart.option;
                        option.dataset.source=data;
                        this.hLoss_chart.setOption(option);
                    }

                    // 热损率曲线
                    if(!this.heatLossRate_chart){
                        this.$nextTick(()=>{
                            this.heatLossRate_chart_creat("heatLossRate",data);
                        });

                    }else{
                        //刷新数据
                        let option = this.heatLossRate_chart.option;
                        option.dataset.source=data;
                        this.heatLossRate_chart.setOption(option);
                    }

                    // 单位长度热损
                    if(!this.heatLossPerMeter_chart){
                        this.$nextTick(()=>{
                            this.heatLossPerMeter_chart_creat("heatLossPerMeter",data);
                        });
                    }else{
                        //刷新数据
                        let option = this.heatLossPerMeter_chart.option;
                        option.dataset.source=data;
                        this.heatLossPerMeter_chart.setOption(option);
                    }

                    // 单位面积热损
                    if(!this.heatLossPerSquare1_heatLossPerSquare2_chart){
                        this.$nextTick(()=>{
                            this.heatLossPerSquare1_heatLossPerSquare2_chart_creat("heatLossPerSquare1_heatLossPerSquare2",data);
                        });
                    }else{
                        //刷新数据
                        let option = this.heatLossPerSquare1_heatLossPerSquare2_chart.option;
                        option.dataset.source=data;
                        this.heatLossPerSquare1_heatLossPerSquare2_chart.setOption(option);
                    }

                    // 分块请求数据
                    this.chunckRefreshData();
                }
            });
        },
        // 定时分页获取数据
        chunckRefreshData(){
            // 弹出提示框，提示用户数据持续加载中
            if(!this.messageTip){
                this.messageTip=this.$message({
                    message: '由于数据量较大，数据会持续加载，请耐心等候',
                    type: 'warning',
                    duration:0
                });
            }
            
            // 两秒钟之后请求另外的数据
            this.chunckTimeId=setTimeout(()=>{
                // 如果当前数据页不是最后的数据页，则继续进行请求
                if(this.page.current<this.page.totalPage){
                    // 增加数据页，并请求下一段数据
                    let page=this.page.current+1;
                    this.getPipelineAnalysisHistory(page,this.page.size,true);
                }else{
                    // 清理定时器及弹出框
                    this.clearWindows();
                    // 弹出提示框，提示用户数据加载完成
                    this.$message({
                        message: '感谢您的耐心等待，数据加载完成',
                        type: 'success',
                    });
                }
            },5000);
  
        },
        // 管道切换
        changePipelineId(val){
            // 清理定时器及弹出框
            this.clearWindows();

            //更换管道
            this.pipelineId=val;
            this.getPipelineAnalysisHistory();
        },
        // 查询报警数据
        searchData(){
            // 清理定时器及弹出框
            this.clearWindows();
            // 发送查询请求
            this.getPipelineAnalysisHistory();
        },
        // 预设事件段
        presetTime(type){
            // 清理定时器及弹出框
            this.clearWindows();

            // 修改预设数据
            let now=new Date();
            let nowObj=this.$moment(now);
            this.end_time=nowObj.format("yyyy-MM-DD HH:mm:ss");
            switch(type){
                case "day":
                    this.start_time=nowObj.add(-1,'days').format("yyyy-MM-DD HH:mm:ss");
                    break;
                case "week":
                    this.start_time=nowObj.add(-1,'weeks').format("yyyy-MM-DD HH:mm:ss");
                    break;
                case "month":
                    this.start_time=nowObj.add(-1,'months').format("yyyy-MM-DD HH:mm:ss");
                    break;
                case "year":
                    this.start_time=nowObj.add(-1,'years').format("yyyy-MM-DD HH:mm:ss");
                    break;
            }
            // 查询数据
            this.getPipelineAnalysisHistory();
        },
        // 进行代码清理，返回初始状态
        clearWindows(){
            // 关闭提示框
            if(this.messageTip){
                this.messageTip.close();
                this.messageTip=null;
            }
            // 清空定时器
            if(this.chunckTimeId){
                clearTimeout(this.chunckTimeId);
                this.chunckTimeId=null;
            }

        },
        // 瞬时流量和瞬时热量
        flowHeat_flowMas_chart_creat:function(id,data){
            let that=this;
            // 判断时候存在相应的节点
            var dom=document.getElementById(id);
            if(!dom){
                return;
            }

            // 计算数据间隔
            var first=data[0];
            var end=data[data.length-1];
            var start_date = that.$moment(first.recordTime,"YYYY-MM-DD HH:mm:ss");
            var end_date = that.$moment(end.recordTime,"YYYY-MM-DD HH:mm:ss");
            //秒
            var seconds = end_date.diff(start_date,"seconds");
            //分钟
            var mintus = (seconds/60);
            //小时
            var hours = (mintus/60);

            var myChart=that.flowHeat_flowMas_chart = echarts.init(dom);
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: '瞬时流量和瞬时热量',
                    y:'top',
                    left: 'center'
                },
                legend: {
                    data: ['瞬时流量(t/h)', '瞬时热量(KJ)'],
                    top: '30px',
                },
                tooltip: {
                    formatter:function(params){
                        var v=params.value;
                        return v.hLoss;
                    }
                },
                dataset: {
                    // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
                    // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
                    dimensions: ['recordTime','flowMass','flowHeat'],
                    source: data

                },
                grid:{
                    y2:100
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        show: true,
                        rotate:70,
                        height:160,
                        textStyle: {
                            color: 'black'
                        },
                        formatter: function(value) {
                            // 如果数据的时间间隔小于一天，只显示小时数
                            if(hours<24){
                                return that.$moment(value).format("DD日HH:mm");
                            }else if(hours>24&&hours<=24*30){ // 如果数据的时间间隔大于一天，小于一个月，只显示天数
                                return that.$moment(value).format("YYYY/MM/DD");
                            }else if(hours>24*30){ // 如果数据的时间间隔大于一个月，只显示月份
                                return that.$moment(value).format("YYYY/MM");
                            }
                        }
                    }
                },
                yAxis: {},
                series: [
                    {
                        name:"瞬时流量(t/h)",
                        type: 'line',
                        smooth: true,
                        itemStyle : {  
                            normal : {  
                                lineStyle:{  
                                    color:'#44a0d6'  
                                } 
                            }  
                        }
                    },
                    {
                        name:"瞬时热量(KJ)",
                        type: 'line',
                        smooth: true,
                        itemStyle : {  
                            normal : {  
                                lineStyle:{  
                                    color:'#37bd86'  
                                } 
                            }  
                        }
                    }
                ]
            };
            this.flowHeat_flowMas_chart.option=option;
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        // 流速曲线图表
        velocity_chart_creat:function(id,data){
            let that=this;
            // 判断时候存在相应的节点
            var dom=document.getElementById(id);
            if(!dom){
                return;
            }

            // 计算数据间隔
            var first=data[0];
            var end=data[data.length-1];
            var start_date = that.$moment(first.recordTime,"YYYY-MM-DD HH:mm:ss");
            var end_date = that.$moment(end.recordTime,"YYYY-MM-DD HH:mm:ss");
            //秒
            var seconds = end_date.diff(start_date,"seconds");
            //分钟
            var mintus = (seconds/60);
            //小时
            var hours = (mintus/60);

            var myChart =that.velocity_chart= echarts.init(dom);
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: '流速(m/s)',
                    y:'top',
                    left: 'center'
                },
                tooltip: {
                    formatter:function(params){
                        var v=params.value;
                        return v.hLoss;
                    }
                },
                dataset: {
                    // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
                    // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
                    dimensions: ['recordTime','velocity'],
                    source: data

                },
                grid:{
                    y2:100
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        show: true,
                        rotate:70,
                        height:160,
                        textStyle: {
                            color: 'black'
                        },
                        formatter: function(value) {
                            // 如果数据的时间间隔小于一天，只显示小时数
                            if(hours<24){
                                return that.$moment(value).format("DD日HH:mm");
                            }else if(hours>24&&hours<=24*30){ // 如果数据的时间间隔大于一天，小于一个月，只显示天数
                                return that.$moment(value).format("YYYY/MM/DD");
                            }else if(hours>24*30){ // 如果数据的时间间隔大于一个月，只显示月份
                                return that.$moment(value).format("YYYY/MM");
                            }
                        }
                    }
                },
                yAxis: {},
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        itemStyle : {  
                            normal : {  
                                lineStyle:{  
                                    color:'#44a0d6'  
                                } 
                            }  
                        }
                    }
                ]
            };
            // 绑定option
            that.velocity_chart.option=option;
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        // 焓降曲线图表
        hLoss_chart_creat:function(id,data){
            let that=this;
            // 判断时候存在相应的节点
            var dom=document.getElementById(id);
            if(!dom){
                return;
            }

            // 计算数据间隔
            var first=data[0];
            var end=data[data.length-1];
            var start_date = that.$moment(first.recordTime,"YYYY-MM-DD HH:mm:ss");
            var end_date = that.$moment(end.recordTime,"YYYY-MM-DD HH:mm:ss");
            //秒
            var seconds = end_date.diff(start_date,"seconds");
            //分钟
            var mintus = (seconds/60);
            //小时
            var hours = (mintus/60);

            var myChart =that.hLoss_chart= echarts.init(dom);
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: '焓降(kJ/kg)',
                    y:'top',
                    left: 'center'
                },
                tooltip: {
                    formatter:function(params){
                        var v=params.value;
                        return v.hLoss;
                    }
                },
                dataset: {
                    // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
                    // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
                    dimensions: ['recordTime','hLoss'],
                    source: data

                },
                grid:{
                    y2:100
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        show: true,
                        rotate:70,
                        height:160,
                        textStyle: {
                            color: 'black'
                        },
                        formatter: function(value) {
                            // 如果数据的时间间隔小于一天，只显示小时数
                            if(hours<24){
                                return that.$moment(value).format("DD日HH:mm");
                            }else if(hours>24&&hours<=24*30){ // 如果数据的时间间隔大于一天，小于一个月，只显示天数
                                return that.$moment(value).format("YYYY/MM/DD");
                            }else if(hours>24*30){ // 如果数据的时间间隔大于一个月，只显示月份
                                return that.$moment(value).format("YYYY/MM");
                            }
                        }
                    }
                },
                yAxis: {},
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        itemStyle : {  
                            normal : {  
                                lineStyle:{  
                                    color:'#44a0d6'  
                                } 
                            }  
                        }
                    }
                ]
            };
            // 绑定option
            that.hLoss_chart.option=option;
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        // 热损率曲线
        heatLossRate_chart_creat:function(id,data){
            let that=this;
            // 判断时候存在相应的节点
            var dom=document.getElementById(id);
            if(!dom){
                return;
            }
            // 计算数据间隔
            var first=data[0];
            var end=data[data.length-1];
            var start_date = that.$moment(first.recordTime,"YYYY-MM-DD HH:mm:ss");
            var end_date = that.$moment(end.recordTime,"YYYY-MM-DD HH:mm:ss");
            //秒
            var seconds = end_date.diff(start_date,"seconds");
            //分钟
            var mintus = (seconds/60);
            //小时
            var hours = (mintus/60);

            var myChart=that.heatLossRate_chart = echarts.init(dom);
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: '热损率(%)',
                    y:'top',
                    left: 'center',
                },
                tooltip: {
                    formatter:function(params){
                        var v=params.value;
                        return v.heatLossRate;
                    }
                },
                dataset: {
                    // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
                    // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
                    dimensions: ['recordTime','heatLossRate'],
                    source: data

                },
                grid:{
                    y2:100
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        show: true,
                        rotate:70,
                        height:160,
                        textStyle: {
                            color: 'black'
                        },
                        formatter: function(value) {
                            // 如果数据的时间间隔小于一天，只显示小时数
                            if(hours<24){
                                return that.$moment(value).format("DD日HH:mm");
                            }else if(hours>24&&hours<=24*30){ // 如果数据的时间间隔大于一天，小于一个月，只显示天数
                                return that.$moment(value).format("YYYY/MM/DD");
                            }else if(hours>24*30){ // 如果数据的时间间隔大于一个月，只显示月份
                                return that.$moment(value).format("YYYY/MM");
                            }
                        }
                    }
                },
                yAxis: {},
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        itemStyle : {  
                            normal : {  
                                lineStyle:{  
                                    color:'#44a0d6'  
                                } 
                            }  
                        }
                    }
                ]
            };
            // 绑定option
            that.heatLossRate_chart.option=option;
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
         // 单位长度热损(w/m)曲线
        heatLossPerMeter_chart_creat:function(id,data){
            let that=this;
            // 判断时候存在相应的节点
            var dom=document.getElementById(id);
            if(!dom){
                return;
            }
            // 计算数据间隔
            var first=data[0];
            var end=data[data.length-1];
            var start_date = that.$moment(first.recordTime,"YYYY-MM-DD HH:mm:ss");
            var end_date = that.$moment(end.recordTime,"YYYY-MM-DD HH:mm:ss");
            //秒
            var seconds = end_date.diff(start_date,"seconds");
            //分钟
            var mintus = (seconds/60);
            //小时
            var hours = (mintus/60);

            var myChart =that.heatLossPerMeter_chart= echarts.init(dom);
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: '单位长度热损(w/m)',
                    y:'top',
                    left: 'center'
                },
                tooltip: {
                    formatter:function(params){
                        var v=params.value;
                        return v.heatLossPerSquare2;
                    }
                },
                dataset: {
                    // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
                    // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
                    dimensions: ['recordTime','heatLossPerMeter'],
                    source: data

                },
                grid:{
                    y2:100
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        show: true,
                        rotate:70,
                        height:160,
                        textStyle: {
                            color: 'black'
                        },
                        formatter: function(value) {
                            // 如果数据的时间间隔小于一天，只显示小时数
                            if(hours<24){
                                return that.$moment(value).format("DD日HH:mm");
                            }else if(hours>24&&hours<=24*30){ // 如果数据的时间间隔大于一天，小于一个月，只显示天数
                                return that.$moment(value).format("YYYY/MM/DD");
                            }else if(hours>24*30){ // 如果数据的时间间隔大于一个月，只显示月份
                                return that.$moment(value).format("YYYY/MM");
                            }
                        }
                    }
                },
                yAxis: {},
                series: [
                    {
                        type: 'line',
                        smooth: true,
                        itemStyle : {  
                            normal : {  
                                lineStyle:{  
                                    color:'#44a0d6'  
                                } 
                            }  
                        }
                    }
                ]
            };
            // 绑定option
            that.heatLossPerMeter_chart.option=option;
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
        // 单位面积热损（w/m2）曲线
        heatLossPerSquare1_heatLossPerSquare2_chart_creat:function(id,data){
            let that=this;
            // 判断时候存在相应的节点
            var dom=document.getElementById(id);
            if(!dom){
                return;
            }
            // 计算数据间隔
            var first=data[0];
            var end=data[data.length-1];
            var start_date = that.$moment(first.recordTime,"YYYY-MM-DD HH:mm:ss");
            var end_date = that.$moment(end.recordTime,"YYYY-MM-DD HH:mm:ss");
            //秒
            var seconds = end_date.diff(start_date,"seconds");
            //分钟
            var mintus = (seconds/60);
            //小时
            var hours = (mintus/60);

            var myChart =that.heatLossPerSquare1_heatLossPerSquare2_chart= echarts.init(dom);
            // 指定图表的配置项和数据
            var option = {
                title: {
                    text: '单位面积热损',
                    y:'top',
                    left: 'center'
                },
                legend: {
                    data: ['单位面积热损(w/m²)', '保温层单位面积热损(w/m²)'],
                    top: '30px',
                },
                tooltip: {
                    formatter:function(params){
                        var v=params.value;
                        return v.heatLossPerSquare2;
                    }
                },
                dataset: {
                    // 这里指定了维度名的顺序，从而可以利用默认的维度到坐标轴的映射。
                    // 如果不指定 dimensions，也可以通过指定 series.encode 完成映射，参见后文。
                    dimensions: ['recordTime','heatLossPerSquare1','heatLossPerSquare2'],
                    source: data

                },
                grid:{
                    y2:100
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        show: true,
                        rotate:70,
                        height:160,
                        textStyle: {
                            color: 'black'
                        },
                        formatter: function(value) {
                            // 如果数据的时间间隔小于一天，只显示小时数
                            if(hours<24){
                                return that.$moment(value).format("DD日HH:mm");
                            }else if(hours>24&&hours<=24*30){ // 如果数据的时间间隔大于一天，小于一个月，只显示天数
                                return that.$moment(value).format("YYYY/MM/DD");
                            }else if(hours>24*30){ // 如果数据的时间间隔大于一个月，只显示月份
                                return that.$moment(value).format("YYYY/MM");
                            }
                        }
                    }
                },
                yAxis: {},
                series: [
                    {
                        name:"单位面积热损(w/m²)",
                        type: 'line',
                        smooth: true,
                        itemStyle : {  
                            normal : {  
                                lineStyle:{  
                                    color:'#44a0d6'  
                                } 
                            }  
                        }
                    },
                    {
                        name:"保温层单位面积热损(w/m²)",
                        type: 'line',
                        smooth: true,
                        itemStyle : {  
                            normal : {  
                                lineStyle:{  
                                    color:'#37bd86'  
                                } 
                            }  
                        }
                    }
                ]
            };
            // 绑定option
            that.heatLossPerSquare1_heatLossPerSquare2_chart.option=option;
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        },
    }
    
}
</script>
<style lang="scss">
.ppcurve{
    padding:10px;

    /**菜单栏 */
    .menu{
        button{
            cursor: pointer;
            span{
                cursor: pointer;
            }
        }
        .years{
            margin-right: 10px;
        }
        .el-form-item{
            margin-bottom:10px;
        }
    }
    
    .chart-wrap{
        .chart_item{
            display: inline-block;
            width:32%;
            height: 400px;
        }
    }

    /**空白 */
    .blank{
        height: 100%;
        width: 100%;
        position: absolute;
        text-align: center;
        vertical-align: middle;
        align-items: center;
        font-size: 45px;
        justify-content: center;
        display: -webkit-flex;
        display: flex;
    }
}
</style>